'use strict';

wbApp.factory('promotionSvc', ['$q', 'membershipSvc', 'membershipStudentSvc',
    function ($q, membershipSvc, membershipStudentSvc) {

        // subjectCategory: 'course' | 'action'
        function getPromotionsByStudentsAsync(userID, students, source, promotionNow, studentPromotionNow, isAdmin) {
            var deferred = $q.defer();

            var st = {};

            var isCourse = source === 'course';
            var isAction = source === 'action';

            var memberships = membershipSvc.getAllValidAsync(promotionNow, /* refresh */ isAdmin);
            var memStudents = membershipStudentSvc.GetByUserValidAsync(userID, studentPromotionNow, /* refresh */ isAdmin);
            memberships.$promise.then(function (memResult) {
                memStudents.$promise.then(function (memStudentsResult) {

                    _.forEach(students, function (student) {

                        st[student.studentID] = [];
                        _.forEach(memResult, function (mem) {
                            var smem = _.find(memStudentsResult, { 'studentID': student.studentID, 'membershipID': mem.id }); 

                            if ((smem && smem.applyToActions && isAction && smem.isValid) ||
                                (smem && smem.applyToCourses && isCourse && smem.isValid) ||
                                (!smem && mem.applyToActions && isAction) ||
                                (!smem && mem.applyToCourses && isCourse)) {

                                if (mem.isClientAssignable || isAdmin || smem) {
                                    st[student.studentID].push({
                                        buy: mem.isMandatory && !smem,
                                        owns: !!smem,
                                        isMandatory: mem.isMandatory,
                                        membershipID: mem.id,
                                        name: mem.name,
                                        description: mem.description,
                                        price: smem != null ? smem.price : mem.price,
                                        discountPct: smem != null ? smem.discountPct : mem.discountPct,
                                        validFrom: smem != null ? smem.validFrom : mem.validFrom,
                                        validTo: smem != null ? smem.validTo : mem.validTo
                                    });
                                }
                            }
                        });
                        
                        _.forEach(_.filter(memStudentsResult, { studentID: student.studentID}), function (smem) {

                            var mem = _.find(memResult, { 'id': smem.membershipID });
                            if (!mem && smem.isValid) {
                                // student membership with no coresponding membership
                                if ((smem.applyToActions && isAction) || (smem.applyToCourses && isCourse)) {
                                    st[student.studentID].push({
                                        buy: false,
                                        owns: true,
                                        isMandatory: false,
                                        membershipID: smem.membershipID,
                                        name: smem.name,
                                        description: smem.description,
                                        price: smem.price,
                                        discountPct: smem.discountPct,
                                        validFrom: smem.validFrom,
                                        validTo: smem.validTo
                                    });
                                }
                            }
                        });
                    });

                    deferred.resolve(st);
                });
            });
 
            st.$promise = deferred.promise;
            return st;
        }

        return {
            getPromotionsByStudentsAsync: getPromotionsByStudentsAsync
        }
    }]);
